export default __webpack_public_path__ + "static/media/grafema_the-essence-collective_06.2e1869fe.jpg";